"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";

import type { ThemeProviderProps } from "next-themes";
import type { ReactNode } from "react";

// Declare `children` explicitly instead of relying on next-themes'
// `ThemeProviderProps extends React.PropsWithChildren` — that indirect
// inheritance is fragile across React type resolution (CI environments can
// lose the `children` prop when @types/react resolution differs).
type Props = Omit<ThemeProviderProps, "children"> & { children: ReactNode };

export function ThemeProvider({ children, ...props }: Props) {
  return <NextThemesProvider {...props}>{children}</NextThemesProvider>;
}
